import { render, staticRenderFns } from "./SocialLead.vue?vue&type=template&id=6d7b0598&scoped=true"
import script from "./SocialLead.vue?vue&type=script&lang=js"
export * from "./SocialLead.vue?vue&type=script&lang=js"
import style0 from "./SocialLead.vue?vue&type=style&index=0&id=6d7b0598&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d7b0598",
  null
  
)

export default component.exports